import React from "react";


export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Nosotros</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              
                <div className="col-lg-6 col-sm-6 col-xs-12 ">
                <h3>Misión</h3>
                  <p>
                    {props.data
                      ? props.data.Why: "loading"}
                  </p>
                </div>
              
                <div className="col-lg-6 col-sm-6 col-xs-12">
                <h3>Visión</h3>
                 <p>
                    {props.data
                      ? props.data.Why2: "loading"}
                  </p>
                </div>
              
            </div>
           
          </div>
      
         
        </div>
      </div>
    </div>
  );
};
